<template>
  <App
    title="商机下发分配"
    :border="false"
    left-arrow
    @click-left="onNavBarClickLeft"
    @click-right="onNavBarClickRight"
  >
    <div
      slot="right"
      v-auth="'OppSend-MassDistribution'"
      style="color:#FB7E01;"
    >
      <a>{{ state === 0 ? '批量分配' : '取消分配' }}</a>
    </div>
    <div class="container">
      <List
        ref="list"
        v-model="selectionList"
        :dataList="dataList"
        @on-load="onLoad"
      />
    </div>
    <Footer
      v-if="state === 1"
      :selection="selectionList"
      :dataList="dataList"
      @on-select="toggleAll(true)"
      @on-cancel="toggleAll(false)"
    />
  </App>
</template>
<script>
import List from './components/list'
import Footer from './components/footer'
import { Toast } from 'vant'
import { areatree, oppSendList } from '@/api/chargequery'

export default {
  name: 'businessAllot',
  components: {
    List,
    Footer
  },
  provide () {
    return {
      getState: () => this.state
    }
  },
  data () {
    return {
      state: 0, // 0: 默认值 1: 批量分配
      isLoading: false,
      dataList: [],
      selectionList: [],
      searchData: {},
    }
  },
  watch: {
    state (value) {
      if (value === 0) {
        this.selectionList = []
      }
    }
  },
  methods: {
    onLoad () {
      // todo
      this.isLoading = true
      this.getData().then(() => {
        this.$refs.list.list.loading = true
        this.isLoading = false
      })

    },
    onNavBarClickLeft () {
      this.$router.go(-1)
    },
    onNavBarClickRight () {
      if (this.isLoading) return
      this.state = this.state === 0 ? 1 : 0
    },
    toggleAll (selectAll) {
      this.$refs.list.toggleAll(selectAll)
    },
    // 获取处理上牌城市展示
    async areatree () {
      const res = await areatree()
      if (res.code === '000000') {
        this.cityList = res.data
      } else {
        Toast('上牌城市获取失败')
      }
    },
    // 获取数据
    async getData () {
      /* Toast.loading({
        message: 'Loading...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true
      }) */
      const { data, code } = await oppSendList(
        {
          page: 1,
          size: 100
        },
        { status: '0' }
      )
      Toast.clear()
      if (code === '000000') {
        if (data.records.length === 0) return Toast('No data')
        // 如果没有id，添加自定义id，避免批量分配全选问题
        data.records.forEach((item, index) => {
          if (!item.id) item.id = index
          this.cityList.forEach(el => {
            if (item.licenseCity === el.value) {
              item.licenseCity = el.label
            } else {
              el.children.forEach(elch => {
                if (item.licenseCity === elch.value) {
                  item.licenseCity = elch.label
                }
              })
            }
          })
        })
        this.dataList = data.records
      } else {
        Toast('请求数据失败')
      }
    },
    async init () {
      this.dataList = []
      await this.areatree()
      await this.getData()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
</style>